import { render, staticRenderFns } from "./BusinessManagement.vue?vue&type=template&id=87b25ca6&scoped=true&"
import script from "./BusinessManagement.vue?vue&type=script&lang=js&"
export * from "./BusinessManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b25ca6",
  null
  
)

export default component.exports